<template>
  <div class="home-quotes">
    <div
      class="home-quotes-wrapper"
      data-aos="fade-right"
      data-aos-duration="1000"
    >
      <div class="home-quotes-left">
        <div class="home-quotes-photos">
          <div
            class="photo-slider"
            data-slider
          >
            <div class="photo-slider__inner">
              <div
                class="photo-slider__photos"
                data-slider-photos
              >
                <div
                  v-for="quote in $quotes"
                  :key="quote.name"
                  class="photo-slider__photo"
                  data-slider-photo
                >
                  <img :src="quote.photos.quote" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="photo-slider-controls"
          data-slider-controls
        >
          <a
            v-for="(quote, index) in $quotes"
            :key="quote.name"
            class="photo-slider-controls__control"
            :class="{ active: index === sliderIndex }"
            href="javascript:void(0)"
            @click="handleSliderControlClick(index)"
          >
          </a>
        </div>
      </div>
      <div class="home-quotes-right">
        <div class="home-quotes-content">
          <div class="home-quotes-content__quotations">
            <div
              v-for="(quote, index) in $quotes"
              :key="quote.name"
              class="home-quotes-content__quotation"
              :style="{ display: index === 0 ? 'block' : 'none'}"
              data-slider-quote
            >
              <span>&ldquo;{{ quote.quote }}&rdquo;</span>
            </div>
          </div>
          <div class="home-quotes-content__authors">
            <div
              v-for="(quote, index) in $quotes"
              :key="quote.name"
              class="home-quotes-content__author"
              :style="{ display: index === 0 ? 'flex' : 'none'}"
              data-slider-author
            >
              <div
                class="home-quotes-content__author-name"
                v-html="quote.formattedName"
              >
              </div>
              <div
                class="home-quotes-content__author-position"
                v-html="quote.position.join('<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imagesLoaded from 'imagesloaded';
import WebFont from 'webfontloader';

export default {
  name: 'HomeQuotes',
  data: function () {
    return {
      sliderInitialized: false,
      sliderIndex: 0,
      sliderInterval: null
    };
  },
  watch: {
    '$route' (to, from) {
      this.setSliderSizeAndScroll();
    }
  },
  mounted () {
    WebFont.load({
      custom: {
        families: ['Knockout', 'Have Heart One'],
      },
      active: () => {
        this.setSliderSizeAndScroll();
        window.addEventListener('resize', this.handleResize);
        this.initializeSlider();
      }
    });
  },
  beforeDestroy () {
    clearInterval(this.sliderInterval);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize () {
      clearInterval(this.sliderInterval);
      this.setSliderSizeAndScroll();
      this.initializeSliderAutoplay();
    },
    initializeSlider () {
      if (this.sliderInitialized) return;
      this.initializeSliderAutoplay();
      this.sliderInitialized = true;
    },
    selectSlide (index) {
      if (this.sliderIndex === index) return;

      this.sliderIndex = index;
      const $photos = $('[data-slider-photos]');
      const $nextPhoto = $('[data-slider-photo]').eq(index);
      const $previousAuthor = $('[data-slider-author]:visible');
      const $nextAuthor = $('[data-slider-author]').eq(index);
      const $previousQuote = $('[data-slider-quote]:visible');
      const $nextQuote = $('[data-slider-quote]').eq(index);

      $photos.get(0).scrollTo({
        left: (
          $nextPhoto.position().left
          + $photos.scrollLeft()
        ),
        behavior: 'smooth',
      });

      $previousAuthor.fadeOut(200, function () {
        $nextAuthor.fadeIn(200);
      });

      $previousQuote.fadeOut(200, function () {
        $nextQuote.fadeIn(200);
      });
    },
    handleSliderControlClick (index) {
      clearInterval(this.sliderInterval);
      this.selectSlide(index);
    },
    initializeSliderAutoplay () {
      this.sliderInterval = setInterval(
        () => {
          const nextIndex = (
            this.sliderIndex === this.$quotes.length - 1
              ? 0
              : this.sliderIndex + 1
          );
          this.selectSlide(nextIndex);
        },
        10000
      );
    },
    setSliderSizeAndScroll () {
      this.setQuoteHeights();
      this.setAuthorHeights();
      imagesLoaded(
        $('[data-slider-photos]').get(0),
        () => {
          this.setPhotoHeights();
          this.makeSpaceForControls();
          this.adjustScroll();
        },
      );
    },
    setQuoteHeights () {
      const $toHideAgain = $('[data-slider-quote]:not(:visible)');
      $toHideAgain.show();
      $('[data-slider-quote]').each((index, element) => {
        $(element).css('height', '');
      });
      const maxHeight = (
        $('[data-slider-quote]').toArray().reduce(
          (max, el) => $(el).outerHeight() > max ? $(el).outerHeight() : max,
          0
        )
      );
      $('[data-slider-quote]').each((index, element) => {
        $(element).css('height', maxHeight + 'px');
      });
      $toHideAgain.hide();
    },
    setPhotoHeights () {
      $('[data-slider-photo]').each((index, element) => {
        $(element).css('height', '');
      });
      const maxHeight = (
        $('[data-slider-photo]').toArray().reduce(
          (max, el) => $(el).height() > max ? $(el).height() : max,
          0
        )
      );
      $('[data-slider-photo]').each((index, element) => {
        $(element).css('height', maxHeight + 'px');
      });
    },
    setAuthorHeights () {
      const $toHideAgain = $('[data-slider-author]:not(:visible)');
      $toHideAgain.show();
      $('[data-slider-author]').each((index, element) => {
        $(element).css('height', '');
      });
      const maxHeight = (
        $('[data-slider-author]').toArray().reduce(
          (max, el) => $(el).height() > max ? $(el).height() : max,
          0
        )
      );
      $('[data-slider-author]').each((index, element) => {
        $(element).css('height', maxHeight + 'px');
      });
      $toHideAgain.hide();
    },
    makeSpaceForControls () {
      $('.home-quotes-left').css(
        'height',
        $('.home-quotes-photos').outerHeight(true)
        + $('[data-slider-controls]').height()
        + 'px'
      );
    },
    adjustScroll () {
      const $photos = $('[data-slider-photos]');
      const $photo = $('[data-slider-photo]').eq(this.sliderIndex);
      $photos.get(0).scrollTo({
        left: (
          $photo.position().left
          + $photos.scrollLeft()
        ),
        behavior: 'instant',
      });
    },
  }
};
</script>
